import { User } from 'src/app/models/user';

export interface AppState {
    user?: User;
    accessToken?: string;
    sideNavOpen: boolean;
}

export const appState: AppState = {
    sideNavOpen: false
}
